import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { routes } from '@app/consts';
import { TranslateService } from '@ngx-translate/core';
import {Location} from '@angular/common'; 

@Component({
  selector: 'app-employee-security',
  templateUrl: './employee-security.component.html',
  styleUrls: ['./employee-security.component.scss']
})
export class EmployeeSecurityComponent implements OnInit {
  navList = [
    {
      text: 'EmployeeSecurity-ResetPassword',
      route: 'Password'
    },
    {
      text: 'EmployeeSecurity-OrganizationalAccess',
      route: 'Organization'
    },
    {
      text: 'EmployeeSecurity-LoginHistory',
      route: 'LoginHistory'
    },
    {
      text: 'EmployeeSecurity-SecurityRoles',
      route: 'SecurityRoles'
    },
    {
      text: 'EmployeeSecurity-DeleteEmployee',
      route: 'DeleteEmployee'
    },
  ]

  selectedComponent: string;
  employeeId: string;
  subSection: string = 'Password';

  constructor(
    public translate: TranslateService,
    private route: ActivatedRoute,
    public router: Router,
    private location: Location
  ) { }

  ngOnInit(): void {
    this.employeeId = this.getIdInURL();
    this.setSubSectionInUrl(this.subSection);
  }

  get sectionInUrl(): string {
    return this.location.path(true);
  }

  getIdInURL(): string {
    let IdInURL: string;
    
    this.route.paramMap.subscribe(
      params => IdInURL = params.get("id")
    )
      
    return IdInURL;
  }

  getSubSectionInURL(): string {
    let subSectionInURL: string;
    
    this.route.paramMap.subscribe(
      params => subSectionInURL = params.get("subSection")
    )
      
    return subSectionInURL;
  }

  setSubSectionInUrl(subSection: string): void {
    this.location.replaceState(`TalentTrack/Edit/${this.employeeId}/EmployeeSecurity/${subSection}`);
    this.subSection = subSection;
  }

}